import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=7fd1cda2&"
import script from "./EditDepartment.vue?vue&type=script&lang=js&"
export * from "./EditDepartment.vue?vue&type=script&lang=js&"
import style0 from "./EditDepartment.vue?vue&type=style&index=0&id=7fd1cda2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports